export default {
    ACURA: {
        name: 'Acura',
        models: [
            {
                value: 'ILX',
                label: 'ILX',
            },
            {
                value: 'MDX',
                label: 'MDX',
            },
            {
                value: 'NSX',
                label: 'NSX',
            },
            {
                value: 'RDX',
                label: 'RDX',
            },
            {
                value: 'RSX',
                label: 'RSX',
            },
            {
                value: 'TL',
                label: 'TL',
            },
            {
                value: 'ACUTLX',
                label: 'TLX',
            },
            {
                value: 'TSX',
                label: 'TSX',
            },
        ],
    },
    ALFA: {
        name: 'Alfa Romeo',
        models: [
            {
                value: 'ALFAGIULIA',
                label: 'Giulia',
            },
            {
                value: 'ALFA4C',
                label: '4C',
            },
            {
                value: 'ALFASTELV',
                label: 'Stelvio',
            },
        ],
    },
    AMC: {
        name: 'AMC',
        models: [
            {
                value: 'EAGLE',
                label: 'Eagle',
            },
        ],
    },
    ASTON: {
        name: 'Aston Martin',
        models: [
            {
                value: 'VANTAGE',
                label: 'V8 Vantage',
            },
            {
                value: 'DB9',
                label: 'DB9',
            },
            {
                value: 'DBS',
                label: 'DBS',
            },
            {
                value: 'VANQUISH',
                label: 'Vanquish',
            },
        ],
    },
    AUDI: {
        name: 'Audi',
        models: [
            {
                value: 'A3',
                label: 'A3',
            },
            {
                value: 'A5',
                label: 'A5',
            },
            {
                value: 'Q3',
                label: 'Q3',
            },
            {
                value: 'AUDQ4ETRN',
                label: 'Q4 e-tron',
            },
            {
                value: 'Q5',
                label: 'Q5',
            },
            {
                value: 'AUDQ6ETRN',
                label: 'Q6 e-tron',
            },
            {
                value: 'Q7',
                label: 'Q7',
            },
            {
                value: 'AUDIQ8',
                label: 'Q8',
            },
        ],
    },
    BENTL: {
        name: 'Bentley',
        models: [
            {
                value: 'ARNAGE',
                label: 'Arnage',
            },
            {
                value: 'BENBENTAY',
                label: 'Bentayga',
            },
            {
                value: 'BENCONT',
                label: 'Continental',
            },
            {
                value: 'BENFLYSPUR',
                label: 'Flying Spur',
            },
            {
                value: 'BENMUL',
                label: 'Mulsanne',
            },
        ],
    },
    BMW: {
        name: 'BMW',
        models: [
            {
                value: '1_SERIES',
                label: '1 Series',
            },
            {
                value: '2_SERIES',
                label: '2 Series',
            },
            {
                value: '3_SERIES',
                label: '3 Series',
            },
            {
                value: '4_SERIES',
                label: '4 Series',
            },
            {
                value: '5_SERIES',
                label: '5 Series',
            },
            {
                value: '6_SERIES',
                label: '6 Series',
            },
            {
                value: '7_SERIES',
                label: '7 Series',
            },
            {
                value: '8_SERIES',
                label: '8 Series',
            },
            {
                value: 'M3',
                label: 'M3',
            },
            {
                value: 'BMWM4',
                label: 'M4',
            },
            {
                value: 'M5',
                label: 'M5',
            },
            {
                value: 'X1',
                label: 'X1',
            },
            {
                value: 'BMWX2',
                label: 'X2',
            },
            {
                value: 'X3',
                label: 'X3',
            },
            {
                value: 'BMWX4',
                label: 'X4',
            },
            {
                value: 'X5',
                label: 'X5',
            },
            {
                value: 'X6',
                label: 'X6',
            },
            {
                value: 'BMWX7',
                label: 'X7',
            },
            {
                value: 'Z3',
                label: 'Z3',
            },
            {
                value: 'Z4',
                label: 'Z4',
            },
        ],
    },
    BUGATTI: {
        name: 'Bugatti',
        models: [
            {
                value: 'BUGCHIRON',
                label: 'Chiron',
            },
            {
                value: 'BUGVEY',
                label: 'Veyron',
            },
        ],
    },
    BUICK: {
        name: 'Buick',
        models: [
            {
                value: 'ENCLAVE',
                label: 'Enclave',
            },
            {
                value: 'BUIENC',
                label: 'Encore',
            },
            {
                value: 'BUIENCGX',
                label: 'Encore GX',
            },
            {
                value: 'BUIENVISI',
                label: 'Envision',
            },
            {
                value: 'BUIENVISTA',
                label: 'Envista',
            },
            {
                value: 'LACROSSE',
                label: 'LaCrosse',
            },
            {
                value: 'LESA',
                label: 'Le Sabre',
            },
            {
                value: 'PARK',
                label: 'Park Avenue',
            },
            {
                value: 'REG',
                label: 'Regal',
            },
            {
                value: 'BUVERANO',
                label: 'Verano',
            },
        ],
    },
    CAD: {
        name: 'Cadillac',
        models: [
            {
                value: 'ATS',
                label: 'ATS',
            },
            {
                value: 'CADCT6',
                label: 'CT6',
            },
            {
                value: 'CTS',
                label: 'CTS',
            },
            {
                value: 'ESCALA',
                label: 'Escalade',
            },
            {
                value: 'ESCALAESV',
                label: 'Escalade ESV',
            },
            {
                value: 'SRX',
                label: 'SRX',
            },
            {
                value: 'CADXT5',
                label: 'XT5',
            },
            {
                value: 'XTS',
                label: 'XTS',
            },
        ],
    },
    CHEV: {
        name: 'Chevrolet',
        models: [
            {
                value: 'CAM',
                label: 'Camaro',
            },
            {
                value: 'COLORADO',
                label: 'Colorado',
            },
            {
                value: 'CORV',
                label: 'Corvette',
            },
            {
                value: 'CHEV150',
                label: 'Silverado 1500',
            },
            {
                value: 'CHEVC25',
                label: 'Silverado 2500',
            },
            {
                value: 'CH3500PU',
                label: 'Silverado 3500',
            },
            {
                value: 'CHEVSUB',
                label: 'Suburban',
            },
            {
                value: 'TAHOE',
                label: 'Tahoe',
            },
        ],
    },
    CHRY: {
        name: 'Chrysler',
        models: [
            {
                value: 'CHRYS200',
                label: '200',
            },
            {
                value: '300',
                label: '300',
            },
            {
                value: 'ASPEN',
                label: 'Aspen',
            },
            {
                value: 'CROSSFIRE',
                label: 'Crossfire',
            },
            {
                value: 'PACIFICA',
                label: 'Pacifica',
            },
            {
                value: 'PTCRUIS',
                label: 'PT Cruiser',
            },
            {
                value: 'CHRYSEB',
                label: 'Sebring',
            },
            {
                value: 'TANDC',
                label: 'Town & Country',
            },
        ],
    },
    DAEW: {
        name: 'Daewoo',
        models: [
            {
                value: 'LEGANZA',
                label: 'Leganza',
            },
            {
                value: 'NUBIRA',
                label: 'Nubira',
            },
        ],
    },
    DATSUN: {
        name: 'Datsun',
        models: [
            {
                value: '510',
                label: '510',
            },
            {
                value: '280Z',
                label: '280ZX',
            },
            {
                value: '300ZX',
                label: '300ZX',
            },
        ],
    },
    DELOREAN: {
        name: 'DeLorean',
        models: [
            {
                value: 'DMC12',
                label: 'DMC-12',
            },
        ],
    },
    DODGE: {
        name: 'Dodge',
        models: [
            {
                value: 'CHALLENGER',
                label: 'Challenger',
            },
            {
                value: 'DODCHAR',
                label: 'Charger',
            },
            {
                value: 'DURANG',
                label: 'Durango',
            },
            {
                value: 'GRANDCARAV',
                label: 'Grand Caravan',
            },
            {
                value: 'RAM1504WD',
                label: 'Ram 1500 Truck',
            },
            {
                value: 'RAM25002WD',
                label: 'Ram 2500 Truck',
            },
            {
                value: 'RAM3502WD',
                label: 'Ram 3500 Truck',
            },
            {
                value: 'VIPER',
                label: 'Viper',
            },
        ],
    },
    EAGLE: {
        name: 'Eagle',
        models: [
            {
                value: 'TALON',
                label: 'Talon',
            },
        ],
    },
    FER: {
        name: 'Ferrari',
        models: [
            {
                value: '458ITALIA',
                label: '458 Italia',
            },
            {
                value: 'F430',
                label: 'F430',
            },
            {
                value: 'FERCALIF',
                label: 'California',
            },
            {
                value: '360',
                label: '360',
            },
            {
                value: 'FERF12BERL',
                label: 'F12 Berlinetta',
            },
            {
                value: 'FER488SPI',
                label: '488 Spider',
            },
            {
                value: 'FER488GTB',
                label: '488 GTB',
            },
            {
                value: 'F355',
                label: 'F355',
            },
        ],
    },
    FIAT: {
        name: 'FIAT',
        models: [
            {
                value: 'FIAT500',
                label: '500',
            },
            {
                value: 'FIAT124SPI',
                label: '124 Spider',
            },
            {
                value: 'FIAT500X',
                label: '500X',
            },
            {
                value: 'FIAT500L',
                label: '500L',
            },
        ],
    },
    FISK: {
        name: 'Fisker',
        models: [
            {
                value: 'KARMA',
                label: 'Karma',
            },
        ],
    },
    FORD: {
        name: 'Ford',
        models: [
            {
                value: 'EDGE',
                label: 'Edge',
            },
            {
                value: 'EXPEDI',
                label: 'Expedition',
            },
            {
                value: 'EXPLOR',
                label: 'Explorer',
            },
            {
                value: 'F150PICKUP',
                label: 'F150',
            },
            {
                value: 'F250',
                label: 'F250',
            },
            {
                value: 'F350',
                label: 'F350',
            },
            {
                value: 'MUST',
                label: 'Mustang',
            },
            {
                value: 'RANGER',
                label: 'Ranger',
            },
        ],
    },
    FREIGHT: {
        name: 'Freightliner',
        models: [
            {
                value: 'FRESPRINT',
                label: 'Sprinter',
            },
        ],
    },
    GENESIS: {
        name: 'Genesis',
        models: [
            {
                value: 'GENG70',
                label: 'G70',
            },
            {
                value: 'GENG80',
                label: 'G80',
            },
            {
                value: 'GENG90',
                label: 'G90',
            },
        ],
    },
    GEO: {
        name: 'Geo',
        models: [
            {
                value: 'GEOTRACK',
                label: 'Tracker',
            },
            {
                value: 'GEOMETRO',
                label: 'Metro',
            },
        ],
    },
    GMC: {
        name: 'GMC',
        models: [
            {
                value: 'ACADIA',
                label: 'Acadia',
            },
            {
                value: 'CANYON',
                label: 'Canyon',
            },
            {
                value: '15SIPU4WD',
                label: 'Sierra 1500',
            },
            {
                value: 'GMCC25PU',
                label: 'Sierra 2500',
            },
            {
                value: 'GMC3500PU',
                label: 'Sierra 3500',
            },
            {
                value: 'TERRAIN',
                label: 'Terrain',
            },
            {
                value: 'YUKON',
                label: 'Yukon',
            },
            {
                value: 'YUKONXL',
                label: 'Yukon XL',
            },
        ],
    },
    HONDA: {
        name: 'Honda',
        models: [
            {
                value: 'ACCORD',
                label: 'Accord',
            },
            {
                value: 'CIVIC',
                label: 'Civic',
            },
            {
                value: 'CRV',
                label: 'CR-V',
            },
            {
                value: 'HONHRV',
                label: 'HR-V',
            },
            {
                value: 'ODYSSEY',
                label: 'Odyssey',
            },

            {
                value: 'PILOT',
                label: 'Pilot',
            },
            {
                value: 'RIDGELINE',
                label: 'Ridgeline',
            },
            {
                value: 'S2000',
                label: 'S2000',
            },
        ],
    },
    AMGEN: {
        name: 'HUMMER',
        models: [
            {
                value: 'HUMMER',
                label: 'H1',
            },
            {
                value: 'H2',
                label: 'H2',
            },
            {
                value: 'H3',
                label: 'H3',
            },
        ],
    },
    HYUND: {
        name: 'Hyundai',
        models: [
            {
                value: 'GENESIS',
                label: 'Genesis',
            },
            {
                value: 'ELANTR',
                label: 'Elantra',
            },
            {
                value: 'GENESISCPE',
                label: 'Genesis Coupe',
            },
            {
                value: 'HYUKONA',
                label: 'Kona',
            },
            {
                value: 'SANTAFE',
                label: 'Santa Fe',
            },
            {
                value: 'SONATA',
                label: 'Sonata',
            },
            {
                value: 'TUCSON',
                label: 'Tucson',
            },
            {
                value: 'VELOSTER',
                label: 'Veloster',
            },
        ],
    },
    INFIN: {
        name: 'INFINITI',
        models: [
            {
                value: 'EX_MODELS',
                label: 'EX Models',
            },
            {
                value: 'FX_MODELS',
                label: 'FX Models',
            },
            {
                value: 'G35',
                label: 'G35',
            },
            {
                value: 'G37',
                label: 'G37',
            },
            {
                value: 'G_MODELS',
                label: 'G Models',
            },
            {
                value: 'M_MODELS',
                label: 'M Models',
            },
            {
                value: 'INFINQ50',
                label: 'Q50',
            },
            {
                value: 'INFINQ60',
                label: 'Q60',
            },
            {
                value: 'QX56',
                label: 'QX56',
            },
            {
                value: 'INFINQX60',
                label: 'QX60',
            },
            {
                value: 'INFINQX70',
                label: 'QX70',
            },
            {
                value: 'INFINQX80',
                label: 'QX80',
            },
        ],
    },
    ISU: {
        name: 'Isuzu',
        models: [
            {
                value: 'RODEO',
                label: 'Rodeo',
            },
            {
                value: 'VEHICROSS',
                label: 'VehiCROSS',
            },
        ],
    },
    JAG: {
        name: 'Jaguar',
        models: [
            {
                value: 'JAGFPACE',
                label: 'F-PACE',
            },
            {
                value: 'JAGFTYPE',
                label: 'F-TYPE',
            },
            {
                value: 'JAGXE',
                label: 'XE',
            },
            {
                value: 'XF',
                label: 'XF',
            },
            {
                value: 'XJ',
                label: 'XJ',
            },
            {
                value: 'JAGXJR',
                label: 'XJR',
            },
            {
                value: 'XJ_SERIES',
                label: 'XJ Series',
            },
            {
                value: 'XK',
                label: 'XK',
            },
            {
                value: 'XKR',
                label: 'XKR',
            },
            {
                value: 'XK_SERIES',
                label: 'XK Series',
            },
        ],
    },
    JEEP: {
        name: 'Jeep',
        models: [
            {
                value: 'CHER',
                label: 'Cherokee',
            },
            {
                value: 'COMPASS',
                label: 'Compass',
            },
            {
                value: 'JEEPGLAD',
                label: 'Gladiator',
            },
            {
                value: 'JEEPGRAND',
                label: 'Grand Cherokee',
            },
            {
                value: 'LIBERTY',
                label: 'Liberty',
            },
            {
                value: 'PATRIOT',
                label: 'Patriot',
            },
            {
                value: 'JEEPRENEG',
                label: 'Renegade',
            },
            {
                value: 'WRANGLER',
                label: 'Wrangler',
            },
        ],
    },
    KARMA: {
        name: 'Karma',
        models: [
            {
                value: 'KARMREVERO',
                label: 'Revero',
            },
        ],
    },
    KIA: {
        name: 'Kia',
        models: [
            {
                value: 'FORTE',
                label: 'Forte',
            },
            {
                value: 'SORENTO',
                label: 'Sorento',
            },
            {
                value: 'OPTIMA',
                label: 'Optima',
            },
            {
                value: 'SEDONA',
                label: 'Sedona',
            },
            {
                value: 'SOUL',
                label: 'Soul',
            },
            {
                value: 'SPORTA',
                label: 'Sportage',
            },
            {
                value: 'KIASTING',
                label: 'Stinger',
            },
            {
                value: 'KIATELLURD',
                label: 'Telluride',
            },
        ],
    },
    LAM: {
        name: 'Lamborghini',
        models: [
            {
                value: 'AVENT',
                label: 'Aventador',
            },
            {
                value: 'GALLARDO',
                label: 'Gallardo',
            },
            {
                value: 'LAMHURACAN',
                label: 'Huracan',
            },
            {
                value: 'MURCIELAGO',
                label: 'Murcielago',
            },
            {
                value: 'LAMURUS',
                label: 'Urus',
            },
        ],
    },
    ROV: {
        name: 'Land Rover',
        models: [
            {
                value: 'DEFEND',
                label: 'Defender',
            },
            {
                value: 'DISCOV',
                label: 'Discovery',
            },
            {
                value: 'ROVDISCSPT',
                label: 'Discovery Sport',
            },
            {
                value: 'LR4',
                label: 'LR4',
            },
            {
                value: 'RANGE',
                label: 'Range Rover',
            },
            {
                value: 'EVOQUE',
                label: 'Range Rover Evoque',
            },
            {
                value: 'RANGESPORT',
                label: 'Range Rover Sport',
            },
            {
                value: 'ROVVELAR',
                label: 'Range Rover Velar',
            },
        ],
    },
    LEXUS: {
        name: 'Lexus',
        models: [
            {
                value: 'ES350',
                label: 'ES 350',
            },
            {
                value: 'ES_MODELS',
                label: 'ES Models',
            },
            {
                value: 'GS350',
                label: 'GS 350',
            },
            {
                value: 'GS_MODELS',
                label: 'GS Models',
            },
            {
                value: 'GX460',
                label: 'GX 460',
            },
            {
                value: 'GX_MODELS',
                label: 'GX Models',
            },
            {
                value: 'IS250',
                label: 'IS 250',
            },
            {
                value: 'IS350',
                label: 'IS 350',
            },
            {
                value: 'IS_MODELS',
                label: 'IS Models',
            },
            {
                value: 'LC_MODELS',
                label: 'LC Models',
            },
            {
                value: 'LS460',
                label: 'LS 460',
            },
            {
                value: 'LS_MODELS',
                label: 'LS Models',
            },
            {
                value: 'LX570',
                label: 'LX 570',
            },
            {
                value: 'LX_MODELS',
                label: 'LX Models',
            },
            {
                value: 'NX_MODELS',
                label: 'NX Models',
            },
            {
                value: 'RC_MODELS',
                label: 'RC Models',
            },
            {
                value: 'RX350',
                label: 'RX 350',
            },
            {
                value: 'RX_MODELS',
                label: 'RX Models',
            },
            {
                value: 'SC_MODELS',
                label: 'SC Models',
            },
            {
                value: 'UX_MODELS',
                label: 'UX Models',
            },
        ],
    },
    LINC: {
        name: 'Lincoln',
        models: [
            {
                value: 'AVIATOR',
                label: 'Aviator',
            },
            {
                value: 'LINCCORS',
                label: 'Corsair',
            },
            {
                value: 'LINCNAUT',
                label: 'Nautilus',
            },
            {
                value: 'NAVIGA',
                label: 'Navigator',
            },
        ],
    },
    LOTUS: {
        name: 'Lotus',
        models: [
            {
                value: 'EVORA',
                label: 'Evora',
            },
            {
                value: 'LOTELISE',
                label: 'Elise',
            },
            {
                value: 'EXIGE',
                label: 'Exige',
            },
        ],
    },
    MAS: {
        name: 'Maserati',
        models: [
            {
                value: 'GRANTURISM',
                label: 'GranTurismo',
            },
            {
                value: 'MASGRECALE',
                label: 'Grecale',
            },
            {
                value: 'GHIB',
                label: 'Ghibli',
            },
            {
                value: 'QP',
                label: 'Quattroporte',
            },
            {
                value: 'MASLEVAN',
                label: 'Levante',
            },
        ],
    },
    MAYBACH: {
        name: 'Maybach',
        models: [
            {
                value: '57',
                label: '57MAYBACH',
            },
            {
                value: '62',
                label: '62MAYBACH',
            },
        ],
    },
    MAZDA: {
        name: 'MAZDA',
        models: [
            {
                value: 'MAZCX3',
                label: 'CX-3',
            },
            {
                value: 'CX-5',
                label: 'CX-5',
            },
            {
                value: 'CX-9',
                label: 'CX-9',
            },
            {
                value: 'MAZDA3',
                label: 'MAZDA3',
            },
            {
                value: 'MAZDA6',
                label: 'MAZDA6',
            },
            {
                value: 'MAZMIATARF',
                label: 'MX-5 Miata RF',
            },
            {
                value: 'MIATA',
                label: 'MX-5 Miata',
            },
            {
                value: 'RX7',
                label: 'RX-7',
            },
        ],
    },
    MCLAREN: {
        name: 'McLaren',
        models: [
            {
                value: 'MCL720S',
                label: '720S',
            },
            {
                value: 'MCL570S',
                label: '570S',
            },
        ],
    },
    MB: {
        name: 'Mercedes-Benz',
        models: [
            {
                value: 'MBAMGGT',
                label: 'AMG GT',
            },
            {
                value: 'A_CLASS',
                label: 'A-Class',
            },
            {
                value: 'C_CLASS',
                label: 'C-Class',
            },
            {
                value: 'CL_CLASS',
                label: 'CL-Class',
            },
            {
                value: 'CLA_CLASS',
                label: 'CLA-Class',
            },
            {
                value: 'CLS_CLASS',
                label: 'CLS-Class',
            },
            {
                value: 'E_CLASS',
                label: 'E-Class',
            },
            {
                value: 'G_CLASS',
                label: 'G-Class',
            },
            {
                value: 'GL_CLASS',
                label: 'GL-Class',
            },
            {
                value: 'GLA_CLASS',
                label: 'GLA-Class',
            },
            {
                value: 'GLC_CLASS',
                label: 'GLC-Class',
            },
            {
                value: 'GLE_CLASS',
                label: 'GLE-Class',
            },
            {
                value: 'GLK_CLASS',
                label: 'GLK-Class',
            },
            {
                value: 'GLS_CLASS',
                label: 'GLS-Class',
            },
            {
                value: 'M_CLASS',
                label: 'M-Class',
            },
            {
                value: 'R_CLASS',
                label: 'R-Class',
            },
            {
                value: 'S_CLASS',
                label: 'S-Class',
            },
            {
                value: 'SL_CLASS',
                label: 'SL-Class',
            },
            {
                value: 'SLC_CLASS',
                label: 'SLC-Class',
            },
            {
                value: 'SLK_CLASS',
                label: 'SLK-Class',
            },
            {
                value: 'MBSPRINTER',
                label: 'Sprinter',
            },
        ],
    },
    MERC: {
        name: 'Mercury',
        models: [
            {
                value: 'MERCGRAND',
                label: 'Grand Marquis',
            },
            {
                value: 'MOUNTA',
                label: 'Mountaineer',
            },
            {
                value: 'MARAUDER',
                label: 'Marauder',
            },
        ],
    },
    MINI: {
        name: 'MINI',
        models: [
            {
                value: 'COOPER',
                label: 'Cooper',
            },
            {
                value: 'COOPERCLUB',
                label: 'Cooper Clubman',
            },
            {
                value: 'COUNTRYMAN',
                label: 'Cooper Countryman',
            },
        ],
    },
    MIT: {
        name: 'Mitsubishi',
        models: [
            {
                value: '3000GT',
                label: '3000GT',
            },
            {
                value: 'ECLIP',
                label: 'Eclipse',
            },
            {
                value: 'LANCERMITS',
                label: 'Lancer',
            },
            {
                value: 'LANCEREVO',
                label: 'Lancer Evolution',
            },
            {
                value: 'OUTLANDER',
                label: 'Outlander',
            },
            {
                value: 'OUTLANDSPT',
                label: 'Outlander Sport',
            },
        ],
    },
    NISSAN: {
        name: 'Nissan',
        models: [
            {
                value: '350Z',
                label: '350Z',
            },
            {
                value: '370Z',
                label: '370Z',
            },
            {
                value: 'ALTIMA',
                label: 'Altima',
            },
            {
                value: 'FRONTI',
                label: 'Frontier',
            },
            {
                value: 'GT-R',
                label: 'GT-R',
            },
            {
                value: 'MAX',
                label: 'Maxima',
            },
            {
                value: 'ROGUE',
                label: 'Rogue',
            },
            {
                value: 'TITAN',
                label: 'Titan',
            },
        ],
    },
    OLDS: {
        name: 'Oldsmobile',
        models: [
            {
                value: 'ALERO',
                label: 'Alero',
            },
            {
                value: 'CSUPR',
                label: 'Cutlass Supreme',
            },
            {
                value: '88',
                label: '88',
            },
        ],
    },
    PLYM: {
        name: 'Plymouth',
        models: [
            {
                value: 'PROWLE',
                label: 'Prowler',
            },
        ],
    },
    PONT: {
        name: 'Pontiac',
        models: [
            {
                value: 'FBIRD',
                label: 'Firebird',
            },
            {
                value: 'G8',
                label: 'G8',
            },
            {
                value: 'GTO',
                label: 'GTO',
            },
            {
                value: 'GP',
                label: 'Grand Prix',
            },
            {
                value: 'SOLSTICE',
                label: 'Solstice',
            },
            {
                value: 'VIBE',
                label: 'Vibe',
            },
            {
                value: 'G6',
                label: 'G6',
            },
        ],
    },
    POR: {
        name: 'Porsche',
        models: [
            {
                value: 'POR718BOX',
                label: '718 Boxster',
            },
            {
                value: 'POR718CAY',
                label: '718 Cayman',
            },
            {
                value: '911',
                label: '911',
            },
            {
                value: 'BOXSTE',
                label: 'Boxster',
            },
            {
                value: 'CAYENNE',
                label: 'Cayenne',
            },
            {
                value: 'CAYMAN',
                label: 'Cayman',
            },
            {
                value: 'PANAMERA',
                label: 'Panamera',
            },
            {
                value: 'PORMACAN',
                label: 'Macan',
            },
        ],
    },
    RAM: {
        name: 'RAM',
        models: [
            {
                value: 'RM1500',
                label: '1500',
            },
            {
                value: 'RM2500',
                label: '2500',
            },
            {
                value: 'RM3500',
                label: '3500',
            },
            {
                value: 'RM4500',
                label: '4500',
            },
            {
                value: 'RM5500',
                label: '5500',
            },
            {
                value: 'RMPROMAST',
                label: 'ProMaster',
            },
        ],
    },
    RR: {
        name: 'Rolls-Royce',
        models: [
            {
                value: 'PHANT',
                label: 'Phantom',
            },
            {
                value: 'WRAI',
                label: 'Wraith',
            },
            {
                value: 'GHOST',
                label: 'Ghost',
            },
            {
                value: 'PRDAWN',
                label: 'Dawn',
            },
            {
                value: 'RRCULLINAN',
                label: 'Cullinan',
            },
        ],
    },
    SAAB: {
        name: 'Saab',
        models: [
            {
                value: '9-2X',
                label: '9-2X',
            },
            {
                value: '9-4X',
                label: '9-4X',
            },
            {
                value: '97X',
                label: '9-7X',
            },
        ],
    },
    SATURN: {
        name: 'Saturn',
        models: [
            {
                value: 'SKY',
                label: 'Sky',
            },
            {
                value: 'VUE',
                label: 'Vue',
            },
        ],
    },
    SCION: {
        name: 'Scion',
        models: [
            {
                value: 'SCIFRS',
                label: 'FR-S',
            },
            {
                value: 'XB',
                label: 'xB',
            },
            {
                value: 'TC',
                label: 'tC',
            },
        ],
    },
    SMART: {
        name: 'smart',
        models: [
            {
                value: 'FORTWO',
                label: 'fortwo',
            },
        ],
    },
    SRT: {
        name: 'SRT',
        models: [
            {
                value: 'SRTVIPE',
                label: 'Viper',
            },
        ],
    },
    SUB: {
        name: 'Subaru',
        models: [
            {
                value: 'SUBCRSSTRK',
                label: 'Crosstrek',
            },
            {
                value: 'FOREST',
                label: 'Forester',
            },
            {
                value: 'IMPREZ',
                label: 'Impreza',
            },
            {
                value: 'IMPWRX',
                label: 'Impreza WRX',
            },
            {
                value: 'SUBOUTBK',
                label: 'Outback',
            },
            {
                value: 'SUBWRX',
                label: 'WRX',
            },
        ],
    },
    SUZUKI: {
        name: 'Suzuki',
        models: [
            {
                value: 'GRANDV',
                label: 'Grand Vitara',
            },
            {
                value: 'SAMUR',
                label: 'Samurai',
            },
            {
                value: 'SX4',
                label: 'SX4',
            },
        ],
    },
    TESLA: {
        name: 'Tesla',
        models: [
            {
                value: 'TESMOD3',
                label: 'Model 3',
            },
            {
                value: 'TESMODS',
                label: 'Model S',
            },
            {
                value: 'TESMODX',
                label: 'Model X',
            },
        ],
    },
    TOYOTA: {
        name: 'Toyota',
        models: [
            {
                value: '4RUN',
                label: '4Runner',
            },
            {
                value: 'CAMRY',
                label: 'Camry',
            },
            {
                value: 'COROL',
                label: 'Corolla',
            },
            {
                value: 'HIGHLANDER',
                label: 'Highlander',
            },
            {
                value: 'PRIUS',
                label: 'Prius',
            },
            {
                value: 'RAV4',
                label: 'RAV4',
            },
            {
                value: 'TACOMA',
                label: 'Tacoma',
            },
            {
                value: 'TUNDRA',
                label: 'Tundra',
            },
        ],
    },
    VOLKS: {
        name: 'Volkswagen',
        models: [
            {
                value: 'VOLKSATL',
                label: 'Atlas',
            },
            {
                value: 'BEETLE',
                label: 'Beetle',
            },
            {
                value: 'GTI',
                label: 'GTI',
            },
            {
                value: 'GOLF',
                label: 'Golf',
            },
            {
                value: 'GOLFR',
                label: 'Golf R',
            },
            {
                value: 'JET',
                label: 'Jetta',
            },
            {
                value: 'PASS',
                label: 'Passat',
            },
            {
                value: 'TIGUAN',
                label: 'Tiguan',
            },
        ],
    },
    VOLVO: {
        name: 'Volvo',
        models: [
            {
                value: 'S60',
                label: 'S60',
            },
            {
                value: 'S90',
                label: 'S90',
            },
            {
                value: 'VOLVOV60',
                label: 'V60',
            },
            {
                value: 'V90',
                label: 'V90',
            },
            {
                value: 'VOLVOXC40',
                label: 'XC40',
            },
            {
                value: 'XC60',
                label: 'XC60',
            },
            {
                value: 'XC',
                label: 'XC70',
            },
            {
                value: 'XC90',
                label: 'XC90',
            },
        ],
    },
    YUGO: {
        name: 'Yugo',
        models: [
            {
                value: 'GV',
                label: 'GV',
            },
            {
                value: 'GVX',
                label: 'GVX',
            },
        ],
    },
    POLESTAR: {
        name: 'Polestar',
        models: [
            {
                value: 'POLESTAR1',
                label: 'Polestar 1',
            },
            {
                value: 'POLESTAR2',
                label: 'Polestar 2',
            },
        ],
    },
    RIVIAN: {
        name: 'Rivian',
        models: [
            {
                value: 'RIVIANR1S',
                label: 'R1S',
            },
            {
                value: 'RIVIANR1T',
                label: 'R1T',
            },
        ],
    },
    LUCID: {
        name: 'Lucid',
        model: [
            {
                value: 'LUCIDAIR',
                label: 'Air',
            },
        ],
    },
};
